import React from 'react';

const PricingIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            {...props}
        >
            <path
                d='M6.75 10.5C6.75 11.7427 8.7645 12.75 11.25 12.75C13.7355 12.75 15.75 11.7427 15.75 10.5C15.75 9.25725 13.7355 8.25 11.25 8.25C8.7645 8.25 6.75 9.25725 6.75 10.5Z'
                stroke='currentColor'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6.75 10.5V13.5C6.75 14.742 8.7645 15.75 11.25 15.75C13.7355 15.75 15.75 14.742 15.75 13.5V10.5'
                stroke='currentColor'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M2.25 4.5C2.25 5.304 3.108 6.0465 4.5 6.4485C5.892 6.8505 7.608 6.8505 9 6.4485C10.392 6.0465 11.25 5.304 11.25 4.5C11.25 3.696 10.392 2.9535 9 2.5515C7.608 2.1495 5.892 2.1495 4.5 2.5515C3.108 2.9535 2.25 3.696 2.25 4.5Z'
                stroke='currentColor'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M2.25 4.5V12C2.25 12.666 2.829 13.0875 3.75 13.5'
                stroke='currentColor'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M2.25 8.25C2.25 8.916 2.829 9.3375 3.75 9.75'
                stroke='currentColor'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default PricingIcon;
